<template>
    <div class='page_content'>
        <div class="content">
            <div class="chat-page-wrapper">
                <database-query  :databaseTable="databaseTable" :suggestions="suggestions" :title="title" />
            </div>
        </div>
    </div>
</template>

<script>
import databaseQuery from '@/components/databaseQuery.vue'

export default {
    name: 'aiCgAnalysis',
    components: {
        databaseQuery
    },
    data() {
        return {
            title: '采购分析',
            databaseTable: 'ai_lx_cg',
            suggestions: ['统计一下本月的采购数量前十名商品', '查询本月采购金额前十名的供应商，使用柱状图帮我分析一下']
        }
    },
    mounted() {
        this.title=JSON.parse(sessionStorage.getItem('savePage')).jurName
    },
    methods: {
    }
}
</script>

<style scoped>
.page_content {
    height: 100%;
    padding: 0;
    margin: 0;
}

.content {
    height: 100%;
    padding: 0;
}

.chat-page-wrapper {
    width: 100%;
    height: 100vh;
}
</style>
